(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('securityEventStates', ["troubleshooting", function (troubleshooting) {
        var data = [
            {
                autoId: 'security_events_table_filter_state_dropdown_item_new',
                id: 'new',
                label: 'New'
            },
            {
                autoId: 'security_events_table_filter_state_dropdown_item_remediated',
                id: 'remediated',
                label: 'Remediated'
            },
            {
                autoId: 'security_events_table_filter_state_dropdown_item_detected',
                id: 'detected',
                label: 'Detected'
            },
            {
                autoId: 'security_events_table_filter_state_dropdown_item_exception',
                id: 'exception',
                label: 'Exception'
            },
            {
                autoId: 'security_events_table_filter_state_dropdown_item_dismissed',
                id: 'dismissed',
                label: 'Dismissed'
            }
        ];
        var debugStates = [
            {
                autoId: 'security_events_table_filter_state_dropdown_item_pending',
                id: 'pending',
                label: 'Analyst Pending'
            },
            {
                autoId: 'security_events_table_filter_state_dropdown_item_disapproved',
                id: 'disapproved',
                label: 'Analyst Dissmissed'
            }
        ];
        var statesMap = {};
        _(data).each(function (state) {
            statesMap[state.id] = state;
        });
        _(debugStates).each(function (state) {
            statesMap[state.id] = state;
        });
        return {
            data: data,
            get: function (id) {
                var found = statesMap[id];
                if (!found) {
                    return {
                        id: id,
                        label: id.charAt(0).toUpperCase() + id.slice(1)
                    };
                }
                return found;
            },
            variants: function () {
                var states = angular.copy(data);
                if (troubleshooting.entityDebugEnabled()) {
                    states = states.concat(angular.copy(debugStates));
                }
                return states;
            },
            defaultDaoParams: function () {
                if (troubleshooting.entityDebugEnabled()) {
                    return {};
                }
                return { filterEnum_current_state: _(data).pluck('id').join(',') };
            }
        };
    }]);
}());